import type { FC } from 'react';
import React from 'react';

import MoonIcon from '@/assets/images/icons/moon.svg';
import SunIcon from '@/assets/images/icons/sun.svg';
import { useAppDispatch, useAppSelector } from '@/hooks/redux-hooks';
import { setTheme } from '@/store/slices/themeSlice';

import Button from '../Button/Button';

interface ThemeSwitcherProps {
  small?: boolean,
}

const ThemeSwitcher: FC<ThemeSwitcherProps> = () => {
  const dispatch = useAppDispatch();
  const { theme } = useAppSelector((state) => state.themeReducer);
  const isDarkTheme = theme === 'dark';
  return (
    <Button
      onClick={() => dispatch(setTheme(isDarkTheme ? 'light' : 'dark'))}
      quad
      outlined
      icon={isDarkTheme ? <SunIcon /> : <MoonIcon />}
    />
  );
};

export default ThemeSwitcher;
